import React from "react";
import {
  FormControl,
  MenuItem,
  CircularProgress,
  TextField,
} from "@mui/material";
import useFirestore from "../../../../config/fireBaseHook";

const TpHeiDropdown = ({
  value,
  onChange,
  name = "HEIProgramCode",
  label = "HEI Program Code",
  fullWidth = true,
  margin = "normal",
  required = false,
  disabled = false,
  size = "small",
  ...otherProps
}) => {
  const { data: heiPrograms, loading, error } = useFirestore("HeiPrograms");

  const handleChange = (event) => {
    if (onChange) {
      // Create a synthetic event-like object to match the expected format
      const syntheticEvent = {
        target: {
          name: name,
          value: event.target.value,
        },
      };
      onChange(syntheticEvent);
    }
  };

  if (loading) {
    return (
      <TextField
        select
        label={label}
        value=""
        disabled
        size={size}
        fullWidth={fullWidth}
        margin={margin}
        {...otherProps}
        helperText={"Loading..."}
      >
        <MenuItem value="">
          <CircularProgress size={20} />
        </MenuItem>
      </TextField>
    );
  }

  if (error) {
    return (
      <TextField
        select
        label={label}
        value=""
        disabled
        size={size}
        fullWidth={fullWidth}
        margin={margin}
        error
        {...otherProps}
        helperText={"Error loading options"}
      >
        <MenuItem value="">
          <span style={{ color: "red" }}>Error loading options</span>
        </MenuItem>
      </TextField>
    );
  }

  // Only include active programs (active === -1 or Active === -1, string or number)
  const filteredHeiPrograms = heiPrograms
    ? heiPrograms.filter((p) => {
        const activeVal = p.active ?? p.Active;
        return activeVal === -1 || activeVal === "-1";
      })
    : [];

  // Sort heiPrograms by display name (HEIProgramName, fallback to Program_Name, ProgramName, ProgramCode, etc.)
  const sortedHeiPrograms = filteredHeiPrograms
    ? [...filteredHeiPrograms].sort((a, b) => {
        const aName =
          a.HEIProgramName ||
          a.Program_Name ||
          a.ProgramName ||
          a.ProgramCode ||
          a.HEI_Program_Code ||
          a.HEIProgramCode ||
          a.id ||
          "";
        const bName =
          b.HEIProgramName ||
          b.Program_Name ||
          b.ProgramName ||
          b.ProgramCode ||
          b.HEI_Program_Code ||
          b.HEIProgramCode ||
          b.id ||
          "";
        return aName.localeCompare(bName);
      })
    : [];

  return (
    <TextField
      select
      label={label}
      value={value || ""}
      onChange={handleChange}
      name={name}
      size={size}
      fullWidth={fullWidth}
      margin={margin}
      required={required}
      disabled={disabled}
      {...otherProps}
    >
      <MenuItem value="">
        <em>Select {label}</em>
      </MenuItem>
      {sortedHeiPrograms.map((program) => {
        const code =
          program.ProgramCode ||
          program.HEI_Program_Code ||
          program.HEIProgramCode ||
          program.id ||
          "";
        const name =
          program.HEIProgramName ||
          program.Program_Name ||
          program.ProgramName ||
          code;
        return (
          <MenuItem key={program.id} value={code}>
            {name + (name && name !== code ? " - " + code : "")}
          </MenuItem>
        );
      })}
    </TextField>
  );
};

export default TpHeiDropdown;
